import { can, canInAnyTeam, type ScopelessFor, type ScopelessPermission } from '@lib/permission';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { type RootState } from '../store';

/**
 * Session-level permission checks. For anything the API returns with its own
 * `myPermissions` — folders, projects, inspections — use `has()` from
 * `@lib/permission` against the resource instead.
 */
const usePermission = () => {
  const user = useSelector((state: RootState) => state.auth.user);

  const canDo = useCallback(
    (permission: ScopelessPermission, teamId?: string) => can(user, permission, teamId),
    [user]
  );

  const canDoInAnyTeam = useCallback(
    (permission: ScopelessFor<'team'>) => canInAnyTeam(user, permission),
    [user]
  );

  return { can: canDo, canInAnyTeam: canDoInAnyTeam, userId: user?.id };
};

export default usePermission;
